import { render, staticRenderFns } from "./selfWithdrawal.vue?vue&type=template&id=60627734&scoped=true"
import script from "./selfWithdrawal.vue?vue&type=script&lang=js"
export * from "./selfWithdrawal.vue?vue&type=script&lang=js"
import style0 from "./selfWithdrawal.vue?vue&type=style&index=0&id=60627734&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60627734",
  null
  
)

export default component.exports